import { Component } from '@angular/core';
import { FilterUIModel } from '../Filters/filterUI.model';
import { AgGridFloatingFilterBase, WSFloatingFilterParams } from './agGridFloatingFilterBase';

@Component({
    selector: 'text-floating-filter-component',
    template: `@if (!(type === 'blank' || type === 'notBlank')) {
            <input
                type="text"
                class="ag-floating-filter-input"
                data-show-value="true"
                data-popup-enabled="true"
                [readOnly]="conditionApplied"
                [(ngModel)]="value"
                (ngModelChange)="valueChange(false)"
            />
        }
        @if (type === 'blank' || type === 'notBlank') {
            <div>
                <span class="reset-value clickable" (click)="clearFilter()">
                    <i class="fa fa-times"></i>
                </span>
                <span>{{ type === 'blank' ? 'Blank' : 'Not Blank' }}</span>
            </div>
        } `,
    styleUrls: ['./agGridFloatingFilter.scss'],
    host: { class: 'ag-input-wrapper' },
    standalone: false,
})
export class AgGridTextFloatingFilterComponent extends AgGridFloatingFilterBase<WSFloatingFilterParams> {
    constructor() {
        super();
    }

    onParentModelChanged(parentModel: FilterUIModel): void {
        // In ag-grid v33+, handler-based filters return a wrapper with _wsFilter containing
        // the real FilterUIModel. Unwrap it to access filterValues for display.
        const model = (parentModel as any)?._wsFilter ?? parentModel;
        this.value = '';
        this.type = this._params.filterParams['defaultOption'];
        if (model && model.filterConditionType) {
            this.value = model.filterValues
                .map((x) =>
                    x.filterType.displayKey === 'blank' || x.filterType.displayKey === 'notBlank'
                        ? `${x.filterType.displayName}`
                        : `${x.filterType.displayName} "${x.filterValue}"`,
                )
                .join(model.filterConditionType === Core.FilterConditionTypeEnum.And ? ' AND ' : ' OR ');
            this.conditionApplied = true;
        } else {
            this.value = model && model.filterValues[0] && model.filterValues[0].filterValue;
            this.type = model && model.filterValues[0] && model.filterValues[0].filterType.displayKey;
            this.conditionApplied = false;
        }
    }
}
